export default __webpack_public_path__ + "files/BIOE4.pdf";